import React from "react";

import StatusBarView from "./StatusBarView";

const labels = {
  created: "Created",
  to_review: "To Review",
  approved: "Approved",
  listing_created: "Listing Created",
  accepted_by_client: "Accepted by Client",
  listing_published: "Listing Published",
};

const sellStructure = [
  "created",
  "to_review",
  "approved",
  "accepted_by_client",
];

const orderWithoutListing = [
  "created",
  "to_review",
  "approved",
  "accepted_by_client",
  "listing_published",
];

const orderWithListing = [
  "created",
  "to_review",
  "listing_created",
  "listing_published",
];

const buildStatusesArray = (quoteStatus, structure, isReassigned = false) => {
  let statuses = [],
    pending = false;

  for (let status of structure) {
    if (quoteStatus === status) {
      pending = true;
      statuses.push({
        label: labels[status],
        status:
          quoteStatus === "approved" || quoteStatus === "accepted_by_client"
            ? "approved"
            : quoteStatus === "to_review" && isReassigned
            ? "orange"
            : "done",
      });
    } else {
      statuses.push({
        label: labels[status],
        status: pending ? "pending" : "done",
      });
    }
  }

  return statuses;
};
const buildSellStatuses = (quote) => {
  return buildStatusesArray(
    quote?.status === "quote_sent" ? "approved" : quote?.status,
    sellStructure
  );
};

const buildOrderWithoutListingStatuses = (quote) => {
  return buildStatusesArray(
    quote?.status === "quote_sent" ? "approved" : quote?.status,
    orderWithoutListing,
    quote?.is_reassigned
  );
};

const buildOrderWithListingStatuses = (quote) => {
  let status = ["new", "submitted"].includes(quote.listing?.status)
    ? "listing_created"
    : "listing_published";

  return buildStatusesArray(status, orderWithListing);
};

const buildStatuses = (quote) => {
  const type = quote.request.request_type;

  if (type === "sell") {
    return buildSellStatuses(quote);
  }

  if (quote?.listing_id && quote.status === "accepted_by_client") {
    return buildOrderWithListingStatuses(quote);
  }

  return buildOrderWithoutListingStatuses(quote);
};

const StatusBar = ({ quote, children }) => {
  const statuses = buildStatuses(quote);

  return <StatusBarView {...{ statuses, quote, children }} />;
};

export default StatusBar;
